import React from 'react';

export function Footer() {
  return (
    <footer className="app-footer">
      <span>TMAG Horaire © 2026</span>
    </footer>
  );
}
